function hasLinguaParams(message, params = ['minChars', 'maxChars']) {
    return params.some((param) => message.indexOf(`{${param}}`) >= 0);
}

function messageInterpolation(message, params) {
    if (params) {
        Object.keys(params).forEach(function(key) {
            message = message.replace(`{${key}}`, params[key]);
        });
    }

    return message;
}

// Computes the message to show if there is a min char condition. Uses lingua to support multiple languages
// For one character needed - 1 more character needed
// For two or more characters needed - (n) more characters needed
// When condition is met - (n) character minimum
function getMinCharMessage({minCharCountMeet, value, minChars, charCount, lingua}) {
    if (!minCharCountMeet && value !== '') {
        let minCharErrorMessage = lingua.minCharErrorMessage;
        if (!hasLinguaParams(minCharErrorMessage)) {
            minCharErrorMessage = `${minCharErrorMessage.trim()} {minChars}`;
        }
        return messageInterpolation(minCharErrorMessage, {minChars: minChars - charCount});
    }

    let minCharMessage = lingua.minCharMessage;

    if (!hasLinguaParams(minCharMessage)) {
        minCharMessage = `{minChars} ${minCharMessage.trim()}`;
    }

    return messageInterpolation(minCharMessage, {minChars});
}

// Check for any errors. Can be due to errorMsg, minimum count or maximum count
function checkForError({errorMsg, hasMinCountError, maxCharCountExceeded}) {
    return !!errorMsg || hasMinCountError || maxCharCountExceeded;
}

// Check for errors due to min count and if the control has been blurred
function checkForMinCountError({minChars, minCharCountMeet, value, hasFocus, hasBeenBlurred}) {
    return minChars > 0 && !minCharCountMeet && ((value !== '' && !hasFocus) || hasBeenBlurred);
}

// Suffix appended to Inline messages ID to reference for aria-describedby
export const FORM_ID_CONSTANTS = {
    MIN_CHAR: '__min-chars',
    MAX_CHAR: '__max-chars',
    HELP_TEXT: '__help'
};


const FormUtil = {
    // Method which computes props to be passed to FormHelpBlock
    computeHelpValues({
        id,
        disabled,
        helpText,
        errorMsg,
        value,
        maxChars,
        minChars,
        lingua,
        hasBeenBlurred,
        onlyShowMsgOnError,
        hasFocus,
        inverse
    }) {
        const message = errorMsg || helpText;
        const charCount = value ? value.length : 0;
        const charCountDisplay = maxChars - charCount;
        const maxCharCountExceeded = maxChars > 0 && charCountDisplay < 0;
        const minCharCountMeet = minChars > 0 && charCount >= minChars;
        const hasMinCountError = checkForMinCountError({minChars, minCharCountMeet, value, hasFocus, hasBeenBlurred});
        const hasError = checkForError({errorMsg, hasMinCountError, maxCharCountExceeded});
        const minCharMessage = getMinCharMessage({minCharCountMeet, value, minChars, charCount, lingua});
        const maxCharMessage = messageInterpolation(lingua.maxCharErrorMessage, {maxChars});
        return {
            id,
            helpText,
            errorMsg,
            message,
            maxChars,
            minChars,
            disabled,
            charCountDisplay,
            onlyShowMsgOnError,
            maxCharCountExceeded,
            minCharCountMeet,
            hasMinCountError,
            minCharMessage,
            maxCharMessage,
            inverse,
            hasError
        };
    },

    // Method used to check if there is a message or char count condition which requires an aria-described by pointer
    needAriaMsg({errorMsg, helpText, minChars, maxCharCountExceeded}) {
        return errorMsg || helpText || minChars || maxCharCountExceeded;
    },

    // Method used to populate the input's aria-describedby prop
    computeAriaMsgList({id, errorMsg, helpText, minChars, maxCharCountExceeded}) {
        let descMsgList = '';
        // if minChar condition exists, a message is always shown
        if (minChars !== 0) {
            descMsgList = `${id}${FORM_ID_CONSTANTS.MIN_CHAR} `;
        }
        // if maxChar condition exists, a message is only shown when it exceeds the limit
        if (maxCharCountExceeded) {
            descMsgList = `${descMsgList}${id}${FORM_ID_CONSTANTS.MAX_CHAR} `;
        }
        if (errorMsg || helpText) {
            descMsgList = `${descMsgList}${id}${FORM_ID_CONSTANTS.HELP_TEXT}`;
        }

        return descMsgList.trim();
    }
};

export default FormUtil;